import { request, exportFile } from '@koi-design/vix-tools';
import {
  parseFileName,
  getFileNameFromContentDisposition,
  packApi
} from '@/libs/tools';

export const evalBaseConfigApi = () => {
  return request({
    url: '/api/api-evaluation/task/common/',
    method: 'get'
  });
};

export const evalTaskListApi = data => {
  return request({
    url: '/api/api-evaluation/task',
    method: 'get',
    data
  });
};

export const saveEvalTaskApi = data => {
  return packApi({
    url: '/api/api-evaluation/task/save/',
    method: 'post',
    data
  });
};

export const evalTaskDetailApi = data => {
  return packApi({
    url: `/api/api-evaluation/task/${data.task_id}/`,
    method: 'get'
  });
};

export const pauseEvalTaskApi = data => {
  return packApi({
    url: `/api/api-evaluation/task/pause/`,
    method: 'post',
    data
  });
};

export const goOnEvalTaskApi = data => {
  return packApi({
    url: `/api/api-evaluation/task/resume/`,
    method: 'post',
    data
  });
};

export const deleteEvalTaskApi = data => {
  return packApi({
    url: `/api/api-evaluation/task/${data.id}/`,
    method: 'delete'
  });
};

export const getUserBotListApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/current_user_robots/',
    method: 'get',
    data
  });
};

export const getPresetEvalSetApi = () => {
  return request({
    url: '/api/admin-api-evaluation/evaluation_dataset',
    method: 'get'
  });
};

export function downloadPresetEvalSetApi(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/api-evaluation/file/download_file/',
      method: 'get',
      data,
      responseType: 'blob',
      catchAll: true
    })
      .then(res => {
        console.log(res.headers['content-disposition']);
        const filename =
          res.headers['content-disposition'] &&
          getFileNameFromContentDisposition(res.headers['content-disposition']);

        const { fileName, extension } = parseFileName(filename);
        resolve(exportFile(res.data, fileName, extension));
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function evalFileTemplateApi(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/api-evaluation/file/template/',
      method: 'get',
      responseType: 'blob',
      catchAll: true,
      data
    })
      .then(res => {
        const filename =
          res.headers['content-disposition'] &&
          getFileNameFromContentDisposition(res.headers['content-disposition']);

        const { fileName, extension } = parseFileName(filename);
        resolve(exportFile(res.data, fileName, extension));
      })
      .catch(err => {
        reject(err);
      });
  });
}

export const evalSetListApi = data => {
  return request({
    url: '/api/api-evaluation/evaluation_dataset',
    method: 'get',
    data
  });
};

export const getSuccessEvalSetListApi = data => {
  return request({
    url: '/api/api-evaluation/evaluation_dataset/success_list/',
    method: 'get',
    data
  });
};

export const addEvalSetApi = (data, responseType) => {
  return packApi(
    {
      url: '/api/api-evaluation/evaluation_dataset/',
      method: 'post',
      data
    },
    responseType
  );
};

export const deleteEvalSetApi = data => {
  return packApi({
    url: `/api/api-evaluation/evaluation_dataset/${data.id}/`,
    method: 'delete'
  });
};

export const evalSeUploadRetryApi = data => {
  return packApi({
    url: `/api/api-evaluation/evaluation_dataset/retry/${data.id}`,
    method: 'post',
    data
  });
};

export const getAnnotationTaskDetailApi = data => {
  return request({
    url: `/api/api-evaluation/annotation/navigate`,
    method: 'get',
    data
  });
};

export const saveAnnotationResultApi = data => {
  return request({
    url: `/api/api-evaluation/annotation/save/`,
    method: 'put',
    data,
    catchAll: true
  });
};

export const updateAnnotationOutputApi = data => {
  return packApi({
    url: `/api/api-evaluation/annotation/output/`,
    method: 'put',
    data
  });
};

export const startAnnotationApi = data => {
  return request({
    url: `/api/api-evaluation/annotation/start/`,
    method: 'post',
    data
  });
};

export function importKnowledgeApi(data) {
  return request({
    url: '/api/api-knowledge/knowledge/kqa/import_qa_from_eval/',
    method: 'post',
    data
  });
}

export const getAnnotationDataListApi = data => {
  return packApi({
    url: `/api/api-evaluation/annotation/data`,
    method: 'get',
    data
  });
};

export const getAnnotationDataDetailApi = data => {
  return packApi({
    url: `/api/api-evaluation/annotation/data/${data.dataId}/`,
    method: 'get'
  });
};

export const batchSaveAnnotationResultApi = data => {
  return packApi({
    url: `/api/api-evaluation/annotation/result/batch_save`,
    method: 'post',
    data
  });
};

export const exportAnnotationResultApi = data => {
  return request({
    url: `/api/api-evaluation/annotation/result/export`,
    method: 'post',
    data,
    responseType: 'blob',
    catchAll: true
  });
};

export const importAnnotationResultApi = data => {
  return packApi({
    url: `/api/api-evaluation/annotation/result/import`,
    method: 'post',
    data
  });
};

export const getKnowledgeBaseListApi = () => {
  return request({
    url: '/api/api-knowledge/knowledge_base/list',
    method: 'get'
  });
};

export const getKnowledgeDatasetListApi = data => {
  return request({
    url: `/api/api-knowledge/knowledge_base/${data.knowledgeBaseId}/datasets`,
    method: 'get'
  });
};

export const importToKnowledgeBaseApi = data => {
  return packApi({
    url: `/api/api-knowledge/qa/import_from_annotation`,
    method: 'post',
    data
  });
};

export const getReasoningDetailApi = data => {
  return packApi({
    url: `/api/api-evaluation/annotation/reasoning/${data.dataId}/${data.agentIndex}`,
    method: 'get'
  });
};
export const getEvaluationDatasetApi = () => {
  return request({
    url: '/api/admin-api-evaluation/evaluation_dataset/',
    method: 'get'
  });
};
// /api/api-evaluation/task/common/
export const getEvaluationTaskCommonApi = () => {
  return request({
    url: '/api/api-evaluation/task/common/',
    method: 'get'
  });
};
// /api/api-evaluation/task/save/
export const saveEvaluationTaskApi = data => {
  return request({
    url: '/api/api-evaluation/task/save/',
    method: 'post',
    data
  });
};

export const exportReportApi = data => {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/api-evaluation/task/${data.task_id}/export_report/`,
      method: 'get',
      responseType: 'blob',
      catchAll: true
    })
      .then(res => {
        const filename =
          res.headers['content-disposition'] &&
          getFileNameFromContentDisposition(res.headers['content-disposition']);

        const { fileName, extension } = parseFileName(filename);
        resolve(exportFile(res.data, fileName, extension));
      })
      .catch(err => {
        reject(err);
      });
  });
};
// /api/api-evaluation/task/preview/
export const previewEvaluationTaskApi = data => {
  return request({
    url: '/api/api-evaluation/task/preview/',
    method: 'get',
    data
  });
};
// saveEvalTaskApi
export const startEvalTaskApi = data => {
  return packApi({
    url: '/api/api-evaluation/task/start/',
    method: 'post',
    data
  });
};

// /api/api-evaluation/file/delete_file/
export const deleteEvalSetFileApi = data => {
  return packApi({
    url: `/api/api-evaluation/file/delete_file/`,
    method: 'post',
    data
  });
};
export const getEvaluationFieldsApi = data => {
  return request({
    url: '/api/api-evaluation/task/evaluation_fields/',
    method: 'get',
    data
  });
};
// /api/api-evaluation/task/user_task_stat/
export const getUserTaskStatApi = () => {
  return request({
    url: '/api/api-evaluation/task/user_task_stat/',
    method: 'get'
  });
};
// /api/admin-api-evaluation/pre_prompts/
export const getPrePromptsApi = () => {
  return request({
    url: '/api/admin-api-evaluation/pre_prompts/',
    method: 'get'
  });
};

export const createBatchTaskDatasetApi = data => {
  return request({
    url: '/api/api-batch-task/dataset/',
    method: 'post',
    data
  });
};

export const updateBatchTaskDatasetApi = (dataset_id, data) => {
  return packApi({
    url: `/api/api-batch-task/dataset/${dataset_id}/`,
    method: 'put',
    data
  });
};

export const deleteBatchTaskDatasetApi = dataset_id => {
  return packApi({
    url: `/api/api-batch-task/dataset/${dataset_id}/`,
    method: 'delete'
  });
};

export const getBatchTaskDatasetListApi = data => {
  return request({
    url: '/api/api-batch-task/dataset/',
    method: 'get',
    data
  });
};

export const getBatchTaskDatasetDetailApi = dataset_id => {
  return request({
    url: `/api/api-batch-task/dataset/${dataset_id}/`,
    method: 'get'
  });
};

export const getBatchTaskRobotsApi = (task_type = 1) => {
  return request({
    url: `/api/api-batch-task/task/robots/`,
    method: 'get',
    data: { task_type }
  });
};

export const createBatchTaskApi = data => {
  return request({
    url: '/api/api-batch-task/task/',
    method: 'post',
    data
  });
};

export const updateBatchTaskApi = (task_id, data) => {
  return request({
    url: `/api/api-batch-task/task/${task_id}/`,
    method: 'put',
    data
  });
};

export const deleteBatchTaskApi = task_id => {
  return request({
    url: `/api/api-batch-task/task/${task_id}/`,
    method: 'delete'
  });
};

export const getBatchTaskListApi = data => {
  return request({
    url: '/api/api-batch-task/task/',
    method: 'get',
    data
  });
};

export const changeBatchTaskStatusApi = data => {
  return request({
    url: '/api/api-batch-task/task/change-status/',
    method: 'post',
    data
  });
};

export const exportBatchTaskReportApi = data => {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/api-batch-task/task/report/`,
      method: 'get',
      data,
      responseType: 'blob',
      catchAll: true
    })
      .then(res => {
        const filename =
          res.headers['content-disposition'] &&
          getFileNameFromContentDisposition(res.headers['content-disposition']);

        const { fileName, extension } = parseFileName(filename);
        resolve(exportFile(res.data, fileName, extension));
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getBatchTaskWhitelistApi = () => {
  return request({
    url: '/api/api-batch-task/task/auth_white_list/',
    method: 'get'
  });
};

export function downloadBatchTaskTemplateApi(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/api-batch-task/file/template/',
      method: 'get',
      responseType: 'blob',
      catchAll: true,
      data
    })
      .then(res => {
        const filename =
          res.headers['content-disposition'] &&
          getFileNameFromContentDisposition(res.headers['content-disposition']);

        const { fileName, extension } = parseFileName(filename);
        resolve(exportFile(res.data, fileName, extension));
      })
      .catch(err => {
        reject(err);
      });
  });
}
